export default {
    zh: {
        bizNo: '业务编号',
        eightBitCodeName: '产品名称',
        taskType: '任务类型',
        audit: "处理",
        sureEnd: "确定要结束工作流吗",
        taskFlow: "任务流程",
        pleaseInputAuditRemark: "请输入审核备注",
    },
    en: {
        bizNo: 'Biz No.',
        eightBitCodeName: 'Product Name',
        taskType: 'Task Type',
        audit: 'processes',
        sureEnd: "Are you sure you want to end the workflow",
        taskFlow: "Task flow",
        pleaseInputAuditRemark: "Please input audit remark!",
    }
}
